module.exports = __webpack_public_path__ + "img/calendar.16acd928.svg";